// Import all actions
import * as actions from "../actions/locationActions";
import config from "../utils/config";

const { address, city, country, countryShortCode, markerPosition, elevation } =
  config.defaultLocation;
  
export const initialState = {
  address,
  city,
  country,
  countryShortCode,
  markerPosition,
  elevation,
};

export default function locationReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_ADDRESS:
      return { ...state, address: action.payload };
    case actions.SET_CITY:
      return { ...state, city: action.payload };
    case actions.SET_COUNTRY:
      return { ...state, country: action.payload };
    case actions.SET_COUNTRY_CODE:
      return { ...state, countryShortCode: action.payload };
    case actions.SET_MARKERPOSITION:
      return {
        ...state,

        markerPosition: {
          //...state.markerPosition,
          lat: action.payload.lat,
          lng: action.payload.lng,
        },
      };
    case actions.SET_LOCATIONOBJECT:
      return {
        ...state,
        address: action.payload.address,
        city: action.payload.city,
        country: action.payload.country,
        countryShortCode: action.payload.countryShortCode,
        markerPosition: action.payload.markerPosition,
        elevation: action.payload.elevation,

        /*markerPosition: {
          //...state.markerPosition,
          lat: action.payload.lat,
          lng: action.payload.lng,
        },*/
      };

    case actions.SET_ELEVATION:
      return {
        ...state,
        elevation: action.payload.elevation,
      };
    case actions.INITIALSTATE:
      return initialState; /*{
        ...state,
        address: initialState.address,
        country: initialState.country,
        countryShortCode: initialState.countryShortCode,

        markerPosition: {
          //...state.markerPosition,
          lat: initialState.markerPosition.lat,
          lng: initialState.markerPosition.lng,
        },
      };*/

    default:
      return state;
  }
}
